exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-66d382e3]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-66d382e3","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Scene.vue
// module id = 133
// module chunks = 1